<template>
  <div class="after-sales">
    <xl-dialog
      :title="$t('design.order.designAdjustment') || '设计调整'"
      v-model="visible"
      width="566px"
      @close="close"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="add-photo">
        <xl-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-position="top"
          show-message
        >
          <xl-form-item prop="photo" :label="$t('design.orderDetail.screenshotInfo') || '截图信息'">
            <xl-upload2
              ref="uploadRef"
              :file-list="form.photoList"
              :text="$t('design.uploadImage') || '上传照片'"
              :tip="$t('design.orderDetail.uploadPhotoTip') || '只支持jpg，png，jpeg，bmp，webp格式'"
              :typeErrorTip="$t('design.orderDetail.uploadPhotoTip') || '只支持jpg，png，jpeg，bmp，webp格式'"
              :typeErrorList="['jpg', 'png', 'jpeg', 'bmp', 'webp']"
              :accept="['.jpg', '.png', '.jpeg', '.bmp', '.webp']"
              drag
              listType="picture-card"
              isBigFile
              :isPrivate="false"
              :auto-upload="true"
              :caseSensitive="false"
              category="dentalx"
              @success="uploadSuccess"
              @remove="handleRemove"
              @error="handelUploadError"
              @progress="handleProgress"
            >
            </xl-upload2>
          </xl-form-item>
          <xl-form-item prop="note" :label="$t('design.remark') || '备注'">
            <xl-input
              v-model="form.note"
              type="textarea"
              :placeholder="$t('design.inputRemark') || '请输入备注内容'"
              show-word-limit
              maxlength="100"
              rows="6"
            ></xl-input>
          </xl-form-item>
        </xl-form>
      </div>
      <template #footer>
        <div class="footer-button">
          <xl-button @click="close">{{$t('design.cancel') || '取消'}}</xl-button>
          <xl-button type="primary" @click="handleSubmit" :loading="!isSubmitting">{{$t('design.submit') || '提交'}}</xl-button>
        </div>
      </template>
    </xl-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import {
  XlDialog,
  XlButton,
  XlForm,
  XlFormItem,
  XlRow,
  XlCol,
  XlInput,
  XlUpload2,
  XlMessage
} from "@shining3d/ui-components";
import { cloneDeep } from "lodash";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import orderApi from "../../../api/order";
import router from "@/router";
import { useStore } from 'vuex';
import Bus from '../../../utils/bus.js';
import _get from 'lodash/get';

const $store = useStore();
const { $t } = useLang("@shining3d/xl-design-order");
const route = router.currentRoute.value;
// 机构id
const institutionId = _get( $store, 'state.factorySelect.id', '' );
const visible = ref(false);
const close = () => {
  visible.value = false;
};
const show = () => {
  visible.value = true;
};
const isSubmitting = ref( true );
//
const initInfo = {
  photoList: [],
  note: "",
  screenshotFiles: []
};
const form = ref(cloneDeep(initInfo));
const formRef = ref();
const rules = {
  // photo: [{ required: true, message: $t('design.orderDetail.screenshotRequire') || "截图不能为空", trigger: "blur" }],
  note: [{ required: true, message: $t('design.orderDetail.remarkRequire') || "备注不能为空", trigger: "blur" }],
};
// 模型上传成功
const uploadSuccess = () => {
  form.value.photoList.forEach((item,index) => {
    form.value.screenshotFiles[index] = {
    cloud: item.response.cloud,
    category: item.response.category,
    dfsID: item.response.dfsID,
		bucket: item.response.bucket,
		fileName: item.response.fileName,
    fileLength: item.response.fileLength,
    endpoint: item.response.endpoint
  }
  })
}
// 上传中
const handleProgress = ( response ) => {
	if ( response?.percent > 0 && response?.percent < 100 ){
		isSubmitting.value = false;
	} else {
		isSubmitting.value = true;
	}
};
const handleRemove = (e) => {
  const { uploadFile } = e;
	const dfsID = uploadFile.response.dfsID;
  if ( form.value.screenshotFiles.some(( v ) => v.dfsID === dfsID )) {
		const index = form.value.screenshotFiles.findIndex(( v ) => v.dfsID === dfsID );
		form.value.screenshotFiles.splice( index, 1 );
	}
};
// 上传失败
const handelUploadError = () => {
	XlMessage({ type: 'error', message: $t('design.uploadError') || '上传失败' });
};
// 提交设计调整
const handleSubmit = () => {
  formRef.value.validate((valid) => {
    if(valid){
      orderApi.adjustOrderDesign({
        screenshotFiles: form.value.screenshotFiles,
        note: form.value.note,
        orderID: route?.params?.id,
        orgID: institutionId
      }).then((res) => {
        if( res && res.status === 'success'){
          XlMessage({ type: 'success', message: $t('design.order.adjustDesignSuccess') || '调整设计成功' });
          Bus.$emit( 'updateOrderList' )
          visible.value = false;
          router.push({name: 'designOrder'});
        } else {
          visible.value = false;
        }
      });
    }
  })
};
defineExpose({ show });
</script>

<style lang="scss" scoped>
.after-sales {
  font-family: 'Alibaba PuHuiTi 2.0';
  .add-photo {
    .email-width {
      width: 664px;
      min-width: 664px;
    }
  }
  :deep(.xl-upload .el-upload-list--picture-card .el-upload-list__item){
    width: 104px;
    height: 104px;
    margin: 0 16px 16px 0 !important;
    .el-progress-circle{
        height: 102px !important;
        width: 102px !important;
    }
  }
  :deep(.xl-upload .el-upload--picture-card){
    width: 104px;
    height: 104px;
    margin-bottom: 16px !important;
    .icon{
        width: 40px !important;
        height: 40px !important;
        margin-top: 12px !important;
    }
  }
  :deep(.xl-upload .el-upload__text){
    margin-top: 0 !important;
    white-space: nowrap;
  }
    :deep(.el-progress){
        width: 102px !important;
    }
    :deep(.xl-upload .el-upload__tip){
        margin-top: -16px !important;
    }
    :deep(.el-form-item .el-form-item__label){
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      color: #42526E;
    }
  .footer-button {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
